var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3 px-4 d-flex justify-space-between align-center"},[_c('Breadcrumbs',{attrs:{"breadcrumbsItems":_vm.breadcrumbs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }